import { MessageBlock } from '@deckee/deck-hand';
import 'moment-timezone';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { captureEvent } from '../../../../services/event-capture';
import { setSideBarNoMenu } from '../../../../services/store/modules/app-controls';
import PageHolderContent from '../../../containers/PageHolderContent/PageHolderContent';
import useAutoFocus from '../../../hooks/use-auto-focus';
import HeaderBarButton from '../../../layouts/components/HeaderBarButton/HeaderBarButton';
import {
  alarmClock,
  back,
  ReactSvg,
  spinner,
} from '../../../shared/vector-images';
import MenuItem from '../../../shared/_deprecated/components/Menu/MenuItem/MenuItem';
import SearchInput from '../../../shared/_deprecated/components/SearchInput/SearchInput';
import HeaderBar from '../../../shared/_deprecated/features/HeaderBar/HeaderBar';

const SearchInputHolder = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 10px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightgrey};
`;

const LoadingSpinnerHolder = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingSpinner = styled(ReactSvg)`
  flex: 1 0 auto;
`;

const MessageHolder = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 15px;
`;

interface ReminderTypes {
  label: string;
  myRemindersItemType: string;
  searchString: string;
}

const RemindersCreateSelectTypePage: FC = () => {
  const history = useHistory();
  const searchInputRef = useAutoFocus(); // add input focus
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState<ReminderTypes[]>([]);
  const [searchValue, setSearchValue] = useState('');

  const updateLocationSearch = async (searchTerm: string) => {
    setIsLoading(true);

    const myRemindersItemTypes: ReminderTypes[] =
      // @ts-ignore
      window.DECKEE_CONFIG &&
      // @ts-ignore
      window.DECKEE_CONFIG.reminders &&
      // @ts-ignore
      JSON.parse(window.DECKEE_CONFIG.reminders.types);

    const foundMyRemindersTypes = myRemindersItemTypes
      // Get search results and sort alphabetically
      .filter((foundMyRemindersType) =>
        foundMyRemindersType.searchString
          .toLowerCase()
          .includes(searchTerm.toLowerCase()),
      )
      .sort((a, b) => (a.label > b.label ? 1 : -1));

    // Add a 'custom' item at the top, to try and prompt people to make their own reminders
    foundMyRemindersTypes.unshift({
      myRemindersItemType: 'custom',
      label: 'Create your own...',
      searchString: 'Create your own...',
    });

    setSearchValue(searchTerm);
    setSearchResults(foundMyRemindersTypes);
    setIsLoading(false);
  };

  const handleBack = async () => {
    await captureEvent({
      type: 'reminders: back to reminders list',
      payload: {},
      sendToAmplitude: true,
    });
    history.goBack();
  };

  const handleSelectType = async (reminderType: string) => {
    await captureEvent({
      type: 'reminders: add reminder - select type',
      payload: {},
      sendToAmplitude: true,
    });
    history.push(`/maps/reminders/new/${reminderType}`);
  };

  useEffect(() => {
    setIsLoading(true);

    dispatch(setSideBarNoMenu());

    updateLocationSearch('');

    setIsLoading(false);
  }, [dispatch]);

  return (
    <PageHolderContent
      isLoading={isLoading}
      headerBarContent={
        <HeaderBar
          leftNode={
            <HeaderBarButton
              ariaLabel="return"
              icon={back()}
              onClick={handleBack}
            />
          }
          centerNode="Select item type"
        />
      }
    >
      {/* Search results loading */}
      {isLoading && (
        <LoadingSpinnerHolder>
          <LoadingSpinner toDisplay={spinner()} width={32} height={32} />
        </LoadingSpinnerHolder>
      )}

      {/* Search box input */}
      {!isLoading && (
        <SearchInputHolder>
          <SearchInput
            placeholder="Search?"
            value={searchValue}
            onInput={(event: { target: { value: string } }) =>
              updateLocationSearch(event.target.value)
            }
            inputRef={searchInputRef}
          />
        </SearchInputHolder>
      )}

      {/** Search Results */}
      {!isLoading &&
        !!searchResults.length &&
        searchResults.map((searchItem) => (
          <MenuItem
            key={searchItem.myRemindersItemType}
            icon={alarmClock()}
            label={searchItem && searchItem.label}
            onClick={() => handleSelectType(searchItem.myRemindersItemType)}
          />
        ))}

      {/* No results message */}
      {!isLoading && !searchResults.length && (
        <MessageHolder>
          <MessageBlock type="warning">
            {`No results found${
              searchValue && ` for "${searchValue}"`
            }. Refine your search.`}
          </MessageBlock>
        </MessageHolder>
      )}
    </PageHolderContent>
  );
};
export default RemindersCreateSelectTypePage;
